var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-input", {
    class: { require: _vm.getRequire && _vm.isNull() },
    attrs: {
      type: "hidden",
      size: "small",
      disabled: _vm.disabled,
      "show-word-limit": "",
      placeholder: "请输入内容",
    },
    on: { input: _vm.input },
    model: {
      value: _vm.val,
      callback: function ($$v) {
        _vm.val = $$v
      },
      expression: "val",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }